import { useState } from 'react';
import Header from '../layout/Header';
import ProgrammeEssorModal from '../components/ProgrammeEssorModal';
import { Landmark } from 'lucide-react';

export default function SolutionsAffairesSubventionsFinancement() {
  const [isProgrammeEssorOpen, setIsProgrammeEssorOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <Header
        title="Subventions & Financement"
        subtitle="Sous-section de Solutions d’affaires dédiée aux leviers de financement, programmes d’aide et opportunités de subventions."
      />

      <div className="max-w-7xl mx-auto px-8 pb-12">
        <div className="bg-white rounded-2xl shadow-md border border-gray-200 overflow-hidden">
          <div className="px-6 py-5 bg-gradient-to-r from-slate-900 via-purple-900 to-fuchsia-900 text-white flex items-center gap-3">
            <div className="w-12 h-12 rounded-2xl bg-white/15 flex items-center justify-center shadow-inner">
              <Landmark className="w-6 h-6 text-white" />
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.25em] text-purple-200 font-semibold">Sous-menu</p>
              <h2 className="text-2xl md:text-3xl font-black">Subventions & Financement</h2>
            </div>
          </div>

          <div className="px-6 py-8 bg-gray-50/80 space-y-6">
            <p className="text-sm text-gray-500">
              Section prête à recevoir les cards PRIsME liées aux subventions, programmes d’aide, cadres de financement et opportunités d’innovation.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <button
                type="button"
                onClick={() => setIsProgrammeEssorOpen(true)}
                className="relative overflow-hidden rounded-3xl shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer h-64 group border border-purple-200 bg-gradient-to-br from-emerald-700 via-teal-700 to-cyan-800 text-left"
              >
                <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_top_left,rgba(255,255,255,0.35),transparent_28%),radial-gradient(circle_at_bottom_right,rgba(255,255,255,0.18),transparent_30%)]" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-white/5 group-hover:from-emerald-950/45 group-hover:via-emerald-800/10 transition-all duration-300" />

                <div className="relative h-full p-6 flex flex-col justify-end text-white">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-10 h-10 rounded-2xl bg-white/15 flex items-center justify-center shadow-inner">
                      <Landmark className="w-5 h-5 text-white" />
                    </div>
                    <h3 className="text-lg font-bold drop-shadow">Programme Essor</h3>
                  </div>
                  <p className="text-xs text-white/90 leading-relaxed drop-shadow mb-1">
                    Card prête pour accueillir le contenu PRIsME du Programme Essor et sa modal dédiée.
                  </p>
                  <span className="inline-flex items-center gap-2 text-[11px] font-semibold text-emerald-100 mt-1">
                    Contenu à venir
                    <span className="w-4 h-4 rounded-full bg-white/20 flex items-center justify-center text-[10px]">
                      →
                    </span>
                  </span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>

      <ProgrammeEssorModal
        isOpen={isProgrammeEssorOpen}
        onClose={() => setIsProgrammeEssorOpen(false)}
      />
    </div>
  );
}
